import React, { useEffect } from "react";
import "./MyAccount.css";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ManageUpdateShippingResetState, FetchMyAccount, UpdatePlanReset, ResetCancelOrderAndFeedback, ResetSubscriptionReactivationResult } from "../../../actions/Dashboard";
import { ManageSubscriptionResetState } from "../../../actions/MyAccount";
import PersonalDetails from "../../../components/DisplayMyAccount/PersonalDetails";
import LegalDocuments from "../../../components/DisplayMyAccount/LegalDocuments";
import UpdateOrCancelCard from "../../../components/DisplayMyAccount/UpdateOrCancelCard";
import { ECOPROTOKEN_CLAIMS, featureSwitchName, LOCALSESSIONDATAKEYS, refreshBtn, USER_PROFILE_EDIT_TYPE } from "../../../constants/AppConstants";
import Loader from "../../../components/shared/loader/Loader";
import ErrorPage from "../../../components/shared/errorPage/ErrorPage";
import {getFeatureSwitchByKey, getLocalSessionData, getUserSessionData } from "../../../utils/Authentication/handleUserSession";
import { routePath } from "../../../constants/Routes";
import customerUserPlaceholderIcon from "../../../assets/images/user-placeholder-icon.svg";
import { AZURE_ADB2C_TENANT_NAME, profileEditRequest, updateUserPasswordRequest, updateUserProfileRequest } from "../../../utils/Authentication/Azure/AuthConfig";
import { AzureADB2CSignInRedirect, MSALInstance } from "../../../utils/Authentication/Azure/MSALInstanceInit";
import * as utils from './MyAccount.js'
import SmartSavings from "../../Dashboard/SmartSavings/SmartSavings";
import MyPlan from "../../../components/DisplayMyAccount/MyPlan.js";

const MyAccountLanding = () => {
  const history = useHistory();
  const userId = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
  const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
  const { t } = useTranslation(["translation"]);
  const dispatch = useDispatch();
  const fetchedMyAccount = useSelector((state) => state.FetchMyAccount);
  const isBrotherPlusFeatureSwitchEnabled = getFeatureSwitchByKey(featureSwitchName.BROTHER_PLUS);

  const moveToEditPage = (page, currentAccount) => {
    dispatch(ManageUpdateShippingResetState());
    dispatch(ManageSubscriptionResetState());
    dispatch(UpdatePlanReset())
    dispatch(ResetSubscriptionReactivationResult())
    dispatch(ResetCancelOrderAndFeedback())
    const isEditPaymentDetails = (currentAccount === "paymentDetails") ? true : false;
    history.push({ pathname: (isEditPaymentDetails) ? routePath.EDIT_PAYMENT : page, state: {
      'accountClicked':currentAccount, data: (isEditPaymentDetails) ?  fetchedMyAccount : null}
    });
  };
  const onTermsAndCondition = (url) => {
    window.open(url, "_blank")
  }
  /**
   * Method to obtain current user email id 
   * to be passed into edit profile and password request wihthout the need to reauthenticate again
   * @returns string | void
   */
 
  useEffect(() => {
    dispatch(FetchMyAccount(userId));
    // eslint-disable-next-line
  }, [dispatch, userId, deviceId]);

  if(fetchedMyAccount.loading) {
    return <Loader></Loader>
  }
  if(fetchedMyAccount.error) {
    return <ErrorPage errorInfo={fetchedMyAccount.error} showRefreshBtn={refreshBtn.HIDE}></ErrorPage>
  }
  return (
    <div>
      <div className="my-account-profile">
        <div className="profile-img">
          <img src={customerUserPlaceholderIcon} alt="user-profile"/>
        </div>
        {/*  @todo Will be enabled after integration
        <div className="f-14 fc-e profile-change">
          {t("DASHBOARD.USER_PROFILE.CHANGE")}
        </div> */}
      </div>
      <div className="container my-account-card mt-30">
        <PersonalDetails myAccountData={fetchedMyAccount}/>
      </div>
      <div className="container my-account-card mt-5">
        <UpdateOrCancelCard
          header={t("DASHBOARD.MY_ACCOUNT_LANDING.UPDATE_PERSONAL_DETAILS")}
        moveToEditPage={()=>utils.onUpdateUserProfile(USER_PROFILE_EDIT_TYPE.profile)}/>
      </div>
      <div className="container my-account-card mt-5">
        <UpdateOrCancelCard
          header={t("DASHBOARD.MY_ACCOUNT_LANDING.CHANGE_PASSWORD")}
        moveToEditPage={()=>utils.onUpdateUserProfile(USER_PROFILE_EDIT_TYPE.password)}/>
      </div>
        <div className="container my-account-card mt-5">
          <UpdateOrCancelCard
            header={t("DASHBOARD.MY_ACCOUNT_LANDING.MANAGE_ADDRESS")}
          moveToEditPage={()=>moveToEditPage( routePath.MANAGE_ADDRESS, "manageAddress" )}/>
        </div>
      <div className="container my-account-card mt-30">
        <MyPlan moveToEditPage={moveToEditPage} paymentCardNumber={fetchedMyAccount?.myAccount?.userPaymentViewModel?.paymentDisplayText} />
      </div>
      <div className="container my-account-card mt-5">
        {/* currently hiding cancel plan as we need to show it in my devices dashboard */}
        {/* <UpdateOrCancelCard
          header={t("DASHBOARD.MY_ACCOUNT_LANDING.CANCEL_PLAN")}
        moveToEditPage={()=>moveToEditPage(routePath.UPDATE_ACCOUNT_CONFIRMATION, "cancelPlan")}
        /> */}
      </div>
      {
        (isBrotherPlusFeatureSwitchEnabled)
        ? <div className="container my-account-card mt-30">
            <SmartSavings variant="myAccount" />
          </div>
        : null
      }
      <div className="container my-account-card mt-30 mb-60">
        <LegalDocuments onTermsAndCondition={onTermsAndCondition}/>
      </div>
    </div>
  );
};

 export const obtainCurrentUserLoginHint = () => {
    let currentAuthAccount = MSALInstance.getAllAccounts();
    if(currentAuthAccount.length > 0){
      return currentAuthAccount[0].idTokenClaims["signInNames.emailAddress"];
    } else {
      console.error('Application Error: Authentication Invalid');
      AzureADB2CSignInRedirect();
    }
  }
export const buildQuery = (URL, queries) => {
    var query = [];
    for (var key in queries) {
      //encode the keys and values this is most necessary for search inputs 
      query.push(encodeURIComponent(key) + '=' + encodeURIComponent(queries[key]));
    }
    //construct new URL
    let new_url = URL + (query.length ? '?' + query.join('&') : '');
    return(new_url);
  }

export const onUpdateUserProfile = (type) => {
    let URL = `https://${AZURE_ADB2C_TENANT_NAME}.b2clogin.com/${AZURE_ADB2C_TENANT_NAME}.onmicrosoft.com/oauth2/v2.0/authorize`;
    let requestQuery;
    if(type === USER_PROFILE_EDIT_TYPE.password){
      requestQuery = {...updateUserPasswordRequest, ...profileEditRequest};
    } else {
      requestQuery = {...updateUserProfileRequest, ...profileEditRequest}
    }
    const loginHint = obtainCurrentUserLoginHint();
    requestQuery.loginHint = loginHint;
    const finalURL = buildQuery(URL, requestQuery);
    window.open(finalURL, "_self");
  }

export default MyAccountLanding;
